// Central fee engine (mirror of backend/pricing.py) so checkout UIs show the
// exact same transparent breakdown the server charges.
export const PAYPAL_PCT = 0.034;
export const PAYPAL_FIXED = 15.0;
export const OR_PCT = 0.03;

const r2 = (v) => Math.round((Number(v) || 0) * 100) / 100;

export function paypalFee(base) {
  return r2(r2(base) * PAYPAL_PCT + PAYPAL_FIXED);
}

export function quote(base, wantOr = false) {
  base = r2(base);
  const orAmount = wantOr ? r2(base * OR_PCT) : 0;
  const fee = paypalFee(base);
  const total = r2(base + orAmount + fee);
  return { base, orApplied: !!wantOr, orRate: OR_PCT, orAmount, paypalFee: fee, total };
}

export function subscriptionAmount(base) {
  base = r2(base);
  return r2(base + paypalFee(base));
}

export const peso = (v) =>
  "\u20b1" + Number(v || 0).toLocaleString("en-PH", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
